module.exports = __webpack_public_path__ + "static/media/stian.bba39642.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stian.svg
// module id = 292
// module chunks = 0